import React, { useEffect } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import './Redux/Store/configureStore';
import ScrollToTop from './ReusableBlocks/ScrollToTop';
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Cookies from 'js-cookie';
// Pages

import PlaybookView from './Pages/Dashboard/External/PlaybookView'
import DwpEmployeeNavigatorLoader from './ReusableBlocks/DwpEmployeeNavigatorLoader';
import { canLoadEmployeeNavigator } from './ReusableBlocks/employeeNavigatorAccess';
import User_Analytics from './Pages/Dashboard/Analytics/SEAnalytics/User_Analytics';
import ManagerConsole from './Pages/Dashboard/Analytics/MangerConsole/ManagerConsole';
import LeadershipConsole from './Pages/Dashboard/Analytics/LeadershipConsole/LeadershipConsole';
import SEActivitiesImpactAnalysisPage from './Pages/Dashboard/Analytics/SalesImpactAnalytics/SEActivitiesImpactAnalysisPage';
import { canAccessLeadershipAnalytics } from './Pages/Dashboard/Analytics/LeadershipConsole/leadershipAnalyticsAccess';
import { canAccessStandaloneSeImpactAnalytics } from './Pages/Dashboard/Analytics/SalesImpactAnalytics/seImpactAnalyticsAccess';
import WhatNew from './Pages/Dashboard/External/WhatNew';
import What from './Pages/Dashboard/External/What';
import AdminHome from './Pages/Dashboard/Admin/AdminHome/AdminHome';
import UsersPage from './Pages/Dashboard/Admin/Users/UsersPage';
import TenantsPage from './Pages/Dashboard/Admin/Tenants/TenantsPage';
import AlertsPage from './Pages/Dashboard/Admin/Alerts/AlertsPage';
import PublicLayout from './Pages/Layout/PublicLayout';
import PrivateLayout from './Pages/Layout/PrivateLayout';
import InnovationSuite from './Pages/InnovationSuite/InnovationSuite';


// Styles
import '../src/Styles/Footer.css'
import '../src/Styles/BackNavbar.css'
import '../src/Styles/Floating.css'
import '../src/Styles/Analytics.css'
import './Styles/MangerConsole.css'
import './Styles/IdeaPage.css'
import './Styles/ModalStyle.css'
import './Styles/LeadershipConsole.css'
import './Styles/Loading.css'
import './Styles/What_new.css'
import './Styles/NotFound.css'
import './Styles/EmailMigrationBanner.css'


// ---------------DC Core Pages -----------------------
// css style//
import '../src/Styles/Login.css'
import '../src/Styles/Homepage.css'
import '../src/Styles/Demo_Catalgue.css'
import '../src/Styles/Demo_details.css'
import '../src/Styles/ResetDemo.css'
import '../src/Styles/UserProfile.css'
import './Styles/TenantBookings.css'
import './Styles/FAQ.css'
import './Styles/search_result.css'
import './Styles/ChangePassword.css'

// Component
import Login from '../src/Pages/AuthPages/Login'
// import AuthCallback from './Pages/AuthPages/AuthCallback';
import ChangePassword from './Pages/AuthPages/ChangePassword';
import ForgotPassword from './Pages/AuthPages/ForgotPassword';
import ResetPassword from "./Pages/AuthPages/ResetPassword";
import AccountCreationForm from './Pages/AuthPages/AccountCreationForm';
import SupportPage from './Pages/Support/SupportPage';
import InternalSupportPage from './Pages/Support/InternalSupportPage';
import Homepage from './Pages/Dashboard/External/Homepage'
import Demo_Catalaugue from './Pages/Dashboard/Demo_Catalgue/Demo_Catalaugue';
import Demo_Details_Page from './Pages/Dashboard/Demo_Catalgue/Demo_Details_Page';
import Reset_Demo from './Pages/Dashboard/Demo_Catalgue/Reset_Demo';
import User_Profile from './Pages/Dashboard/External/User_Profile';
import Tenant_Book from './Pages/Dashboard/Tenant_Booking/Tenant_Book';
import FAQ_Page from './Pages/Dashboard/External/FAQ_Page';
import FAQ_Page_Quest from './Pages/Dashboard/External/FAQ_Page_Quest';
import Search_Result from './Pages/Dashboard/External/Search_Result';
import NotFound from './Pages/Dashboard/External/NotFound'
import UpdateEmail from './Pages/Dashboard/External/UpdateEmail';
import EmailVerificationSent from './Pages/Dashboard/External/EmailVerificationSent';
import EmailUpdated from './Pages/Dashboard/External/EmailUpdated';
import EmailVerificationInvalid from './Pages/Dashboard/External/EmailVerificationInvalid';
import EmailChangeVerify from './Pages/Dashboard/External/EmailChangeVerify';
import Yads_Ingestion from './Pages/Dashboard/Yads/Yads_Ingestion';



//------------ Learning Hub Part ----------------------

// Css Style //
import './Styles/LearningHubMicroCerts.css'
import './Styles/LearningHub.css'
import './Styles/Yads_ingestion.css'
// Component
import LearningHubHome from './Pages/Dashboard/LearningHub/LearningHubHome';
import LearningHubMicroCerts from './Pages/Dashboard/LearningHub/MicroCerts';
import LearningHubCourse from './Pages/Dashboard/LearningHub/LearningHubCourse';
import DemoCentralTraining from './Pages/Dashboard/LearningHub/DemoCentralTraining'




import SecureViewer  from './Pages/Dashboard/SalesPage/SecureViewer';


// ---------------------Content Hub Part -----------------//
//css style
import './Styles/Content_Store.css'
import './Styles/Content_Store_FIles.css'
import './Styles/Admin.css'
import './Styles/AdminUsers.css'
import './Styles/AdminTenants.css';
import './Styles/AdminAlerts.css';
import './Styles/SharedTenantManagement.css';
//components
import Content_Store from './Pages/Dashboard/ContentStore/Content_Store_v2';
import Content_Store_Files from './Pages/Dashboard/ContentStore/Content_Store_FIles';
import Content_Store_Det from './Pages/Dashboard/ContentStore/Content_Store_FIles_Det';


import SalesDashboard from './Pages/Dashboard/SalesPage/SalesDashboard'
import Onboarding from "./Pages/Dashboard/SalesPage/Onboarding"; // Import the onboarding page

import './Styles/Sales.css'

import './Styles/SalesAnalyticd.css'
import './Styles/sales-onboarding.css'
import './Styles/PartnerPortal.css'
import './Styles/PartnerSidebar.css'
import './Styles/PartnerForms.css'
import './Styles/PartnerTables.css'
import './Styles/PartnerPortalListTable.css'
import './Styles/PartnerDashboard.css'
import './Styles/PartnerPortalPages.css'
import SubmitProjectPage from './Pages/Dashboard/PartnerPortal/Pages/SubmitProjectPage';
import MyProjectsPage from './Pages/Dashboard/PartnerPortal/Pages/MyProjectsPage';
import PSMQueuePage from './Pages/Dashboard/PartnerPortal/Pages/PSMQueuePage';
import PartnerCompaniesPage from './Pages/Dashboard/PartnerPortal/Pages/PartnerCompaniesPage';
import PAEOperationsPage from './Pages/Dashboard/PartnerPortal/Pages/PAEOperationsPage';
import LeadershipDashboardPage from './Pages/Dashboard/PartnerPortal/Pages/LeadershipDashboardPage';
import NotAuthorizedPage from './Pages/Dashboard/PartnerPortal/Pages/NotAuthorizedPage';
import PartnerRouteGuard from './Pages/Dashboard/PartnerPortal/Pages/PartnerRouteGuard';
import {
  PartnerProjectDetailRedirect,
  PartnerPAEProjectDetailRedirect,
} from './Pages/Dashboard/PartnerPortal/Pages/PartnerPortalRedirects';
import { PARTNER_PORTAL_NOT_AUTHORIZED } from './Pages/Dashboard/PartnerPortal/Constants/partnerRoutes';
import { usePartnerRoleAccess } from './Pages/Dashboard/PartnerPortal/Hooks/usePartnerRoleAccess';
import { partnerRoleService } from './Pages/Dashboard/PartnerPortal/Services/partnerRoleService';
import { useFeatureFlags } from './FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from './FeatureFlags/featureFlagConstants';
import FeatureFlagRedirect from './FeatureFlags/FeatureFlagRedirect';

const PrivateRoute = ({ element }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const passwordExpired = Cookies.get('passwordExpired') === 'true'

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (passwordExpired) {
    return <Navigate to="/change-password" replace />;
  }

  return <PrivateLayout>{element}</PrivateLayout>;
};

const EmailMigrationPublicRoute = ({ element }) => (
  <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
    <div className="private-layout-email-migration-mode">
      {element}
    </div>
  </SnackbarProvider>
);

const PartnerPortalHomeRedirect = () => {
  const access = usePartnerRoleAccess();
  const target = access.getDefaultRoute();

  if (!target) {
    return <Navigate to={PARTNER_PORTAL_NOT_AUTHORIZED} replace />;
  }

  return <Navigate to={target} replace />;
};

const App = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  // Read values directly from cookies
  const passwordExpired = Cookies.get('passwordExpired') === 'true';
  const confirmedPasswordExpired = Cookies.get('confirmedPasswordExpired') === 'true';
  const temporaryToken = Cookies.get('temporaryToken');

  

  const currentUser = useSelector(state => state.auth?.currentUser);

  const isSalesUser = currentUser?.typeOfUser === 'Sales';
  const isPAERoleUser = partnerRoleService.isPAERoleUser(currentUser);
  const isLeadershipTypeUser = currentUser?.typeOfUser === 'Leadership';
  const canAccessPartnerPortal = partnerRoleService.hasPartnerPortalAccess(currentUser);
  const canAccessPartnerPages = partnerRoleService.isAdminUser(currentUser)
    || partnerRoleService.isPAEUser(currentUser)
    || partnerRoleService.isLeadershipUser(currentUser)
    || partnerRoleService.isPartnerUser(currentUser);
  const canAccessPAEPages = partnerRoleService.isAdminUser(currentUser)
    || partnerRoleService.isPAEUser(currentUser)
    || partnerRoleService.isLeadershipUser(currentUser);
  const canAccessLeadershipPages = partnerRoleService.isAdminUser(currentUser)
    || partnerRoleService.isPAEUser(currentUser)
    || partnerRoleService.isLeadershipUser(currentUser);
  const { isFeatureEnabled } = useFeatureFlags();

  const enableDemoIngestions = isFeatureEnabled(FEATURE_FLAGS.EnableDemoIngestions);
  const enableBookings = isFeatureEnabled(FEATURE_FLAGS.EnableBookings);
  const enableSalesDemo = isFeatureEnabled(FEATURE_FLAGS.EnableSalesDemo);
  const enableContentStore = isFeatureEnabled(FEATURE_FLAGS.EnableContentStore);
  const enableEnablement = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  const enablePartnerPortal = isFeatureEnabled(FEATURE_FLAGS.EnablePartnerPortal);
  const enableAnalytics = isFeatureEnabled(FEATURE_FLAGS.EnableAnalytics);
  const enableAdmin = isFeatureEnabled(FEATURE_FLAGS.EnableAdmin);
  const enableAccountManagement = isFeatureEnabled(FEATURE_FLAGS.EnableAccountManagement);
  const enableTenantManagement = isFeatureEnabled(FEATURE_FLAGS.EnableTenantManagement);
  const enableAlertManagement = isFeatureEnabled(FEATURE_FLAGS.EnableAlertManagement);
  const enableForgetPassword = isFeatureEnabled(FEATURE_FLAGS.EnableForgetPassword);
  const enableAccountRequest = isFeatureEnabled(FEATURE_FLAGS.EnableAccountRequest);
  const enableWhatsNew = isFeatureEnabled(FEATURE_FLAGS.EnableWhatsNew);
  const enableFaq = isFeatureEnabled(FEATURE_FLAGS.EnableFAQ);
  const enableSearch = isFeatureEnabled(FEATURE_FLAGS.EnableSearch);
  const enableEmailMigration = isFeatureEnabled(FEATURE_FLAGS.EnableEmailMigration);
  const enableSupport = isFeatureEnabled(FEATURE_FLAGS.EnableSupport);
  const enableAgent = isFeatureEnabled(FEATURE_FLAGS.EnableAgent);


  // PUBLIC list
  const PUBLIC_PATHS = [
    '/',
    '/login',
    '/forgot-password',
    '/change-password',
    '/reset-password',
    '/create-account',
    ...(enableSupport ? ['/support'] : []),
    '/email-change/verify',
    '/email-updated',
    '/email-verification-invalid',
  ];
  const isPublicPath = PUBLIC_PATHS.includes(location.pathname);
  const shouldLoadDwpNavigator = isAuthenticated
    && !isPublicPath
    && enableAgent
    && canLoadEmployeeNavigator(currentUser)
    // && partnerRoleService.isAdminUser(currentUser); // Temporary: Admins only


  useEffect(() => {
    const pathname = location.pathname;
    const isPublic = PUBLIC_PATHS.includes(pathname);

    // Redirect to login if user is not authenticated and password is not expired
    if (!isAuthenticated && !passwordExpired) {
      if (!isPublic) navigate('/login', { replace: true });
      return;
    }

    // If password expired but user hasn't confirmed yet, don't redirect
    if (passwordExpired && !confirmedPasswordExpired) {
      return;
    }

    // If password expired and confirmed, and the temporary token exists, redirect to changePassword
    // if (passwordExpired && confirmedPasswordExpired && temporaryToken) {
    //   navigate('/changePassword');
    // }
    // If password expired and confirmed, and the temporary token exists,
    // allow access to both / and /changePassword — restrict everything else
    if (passwordExpired && confirmedPasswordExpired && temporaryToken) {
      const allowed = [
        '/',
        '/login',
        '/change-password',
        '/forgot-password',
        '/reset-password',
        ...(enableSupport ? ['/support'] : []),
      ];
      if (!allowed.includes(pathname)) navigate('/change-password', { replace: true });
      return;
    }

    // If user tries to access changePassword but has no temporary token, redirect to login
    if (passwordExpired && confirmedPasswordExpired && !temporaryToken) {
      if (!isPublic) navigate('/login', { replace: true });
    }

  }, [isAuthenticated, passwordExpired, confirmedPasswordExpired, temporaryToken, location.pathname, navigate, enableSupport]);

  const shouldShowDemoCatalogue = currentUser?.canDemo || isPAERoleUser;
  const shouldShowBookingPage = isPAERoleUser
    || isLeadershipTypeUser
    || (currentUser?.canDemo && !['IZOT',].includes(currentUser?.roleOfUser));





  const renderAdminRoutes = () => {
    if (!enableAdmin) {
      return null;
    }

    return (
      <>
        <Route path="/admin" element={<PrivateRoute element={<AdminHome />} />} />
        {enableAccountManagement && (
          <Route path="/admin/users" element={<PrivateRoute element={<UsersPage />} />} />
        )}
        {enableTenantManagement && (
          <Route path="/admin/tenants" element={<PrivateRoute element={<TenantsPage />} />} />
        )}
        {enableAlertManagement && (
          <Route path="/admin/alerts" element={<PrivateRoute element={<AlertsPage />} />} />
        )}
      </>
    );
  };

  const roleRoutes = () => {
    const { typeOfUser, isManager, country } = currentUser || {};

    // Restrict analytics pages if the user is from Germany
    const isRestrictedCountry = country === 'Germany';

    if (typeOfUser === 'Internal SE') {
      if (isManager) {
        // Condition 1: Internal SE and Manager
        return !isRestrictedCountry && enableAnalytics ? (
          <>
            <Route path="/profile/manager-console" element={<PrivateRoute element={<ManagerConsole />} />} />
            <Route path="/profile/analytics" element={<PrivateRoute element={<User_Analytics />} />} />
          </>
        ): null;
      }

      // Condition 2: Internal SE and NOT Manager
      return !isRestrictedCountry && enableAnalytics ?(
        <Route path="/profile/analytics" element={<PrivateRoute element={<User_Analytics />} />} />
      ):null;
    }
    if (typeOfUser === 'Leadership' || currentUser?.roleOfUser === 'Leadership') {
      // Condition 3: Leadership users
      return !isRestrictedCountry && enableAnalytics ?(
        <Route path="/profile/leadership-console" element={<PrivateRoute element={<LeadershipConsole />} />} />
      ):null;
    }
    if (typeOfUser === 'Admin') {
      if (isManager) {
        // Condition 4: Admin and Manager
        return !isRestrictedCountry ?(
          <>
            {renderAdminRoutes()}
            {enableAnalytics && (
              <>
                <Route path="/profile/leadership-console" element={<PrivateRoute element={<LeadershipConsole />} />} />
                <Route path="/profile/analytics" element={<PrivateRoute element={<User_Analytics />} />} />
                <Route path="/profile/manager-console" element={<PrivateRoute element={<ManagerConsole />} />} />
              </>
            )}
          </>
        ):null;
      }

      // Condition 5: Admin and NOT Manager
      return !isRestrictedCountry ?(
        <>
          {renderAdminRoutes()}
          {enableAnalytics && (
            <>
              <Route path="/profile/leadership-console" element={<PrivateRoute element={<LeadershipConsole />} />} />
              <Route path="/profile/analytics" element={<PrivateRoute element={<User_Analytics />} />} />
            </>
          )}
        </>
      ):null;
    }

    if (
      canAccessLeadershipAnalytics(currentUser)
      && typeOfUser !== 'Leadership'
      && typeOfUser !== 'Admin'
      && !isRestrictedCountry
      && enableAnalytics
    ) {
      return (
        <Route path="/profile/leadership-console" element={<PrivateRoute element={<LeadershipConsole />} />} />
      );
    }

    // Default case: No matching role or type
    return null;
  };










  return (
    <>
      <ScrollToTop />
      <DwpEmployeeNavigatorLoader shouldLoad={shouldLoadDwpNavigator} />
      <FeatureFlagRedirect />

      <Routes>
        {/* Public Route */}
        <Route path="/" element={<PublicLayout><Login /></PublicLayout>} />
        <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
        {enableForgetPassword && (
          <>
            <Route path="/forgot-password" element={<PublicLayout><ForgotPassword /></PublicLayout>} />
            <Route path="/reset-password" element={<PublicLayout><ResetPassword /></PublicLayout>} />
          </>
        )}
        {enableAccountRequest && (
          <Route path="/create-account" element={<PublicLayout><AccountCreationForm /></PublicLayout>} />
        )}
        {enableSupport && (
          <Route path="/support" element={<SupportPage />} />
        )}
        {enableEmailMigration && (
          <>
            <Route path="/email-change/verify" element={<EmailMigrationPublicRoute element={<EmailChangeVerify />} />} />
            <Route path="/email-updated" element={<EmailMigrationPublicRoute element={<EmailUpdated />} />} />
            <Route path="/email-verification-invalid" element={<EmailMigrationPublicRoute element={<EmailVerificationInvalid />} />} />
          </>
        )}
        {/* Allow access to Change Password only if the password is expired */}
        {/* Only allow /changePassword if the user has a temporary token */}
        {passwordExpired && temporaryToken && confirmedPasswordExpired && (
          <Route path="/change-password" element={<ChangePassword />} />
        )}


        {/* Private Routes */}
        <Route path="/home" element={<PrivateRoute element={<Homepage />} />} />
        {enableAgent && (
          <Route path="/innovation-suite" element={<PrivateRoute element={<InnovationSuite />} />} />
        )}
        {enableSupport && (
          <>
            <Route path="/demo-support" element={<PrivateRoute element={<InternalSupportPage />} />} />
            <Route path="/internal-support" element={<PrivateRoute element={<Navigate to="/demo-support" replace />} />} />
          </>
        )}
        {enableEmailMigration && (
          <Route path="/email-verification-sent" element={<PrivateRoute element={<EmailVerificationSent />} />} />
        )}
        <Route path="/partner-portal/not-authorized" element={<PrivateRoute element={<NotAuthorizedPage />} />} />
        {canAccessPartnerPortal && enablePartnerPortal && (
          <>
            <Route path="/partner-portal" element={<PrivateRoute element={<PartnerRouteGuard><PartnerPortalHomeRedirect /></PartnerRouteGuard>} />} />
            {canAccessPartnerPages && (
              <>
                <Route path="/partner-portal/submit" element={<PrivateRoute element={<PartnerRouteGuard><SubmitProjectPage /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/my-projects" element={<PrivateRoute element={<PartnerRouteGuard><MyProjectsPage /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/project-detail" element={<PrivateRoute element={<PartnerRouteGuard><PartnerProjectDetailRedirect /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/project-detail/:id" element={<PrivateRoute element={<PartnerRouteGuard><PartnerProjectDetailRedirect /></PartnerRouteGuard>} />} />
              </>
            )}
            {canAccessPAEPages && (
              <>
                <Route path="/partner-portal/pae/project-queue" element={<PrivateRoute element={<PartnerRouteGuard><PSMQueuePage /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/pae/project-detail" element={<PrivateRoute element={<PartnerRouteGuard><PartnerPAEProjectDetailRedirect /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/pae/project-detail/:id" element={<PrivateRoute element={<PartnerRouteGuard><PartnerPAEProjectDetailRedirect /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/pae/project/:id" element={<PrivateRoute element={<PartnerRouteGuard><PartnerPAEProjectDetailRedirect /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/pae/partner-companies" element={<PrivateRoute element={<PartnerRouteGuard><PartnerCompaniesPage /></PartnerRouteGuard>} />} />
                <Route path="/partner-portal/pae/operations" element={<PrivateRoute element={<PartnerRouteGuard><PAEOperationsPage /></PartnerRouteGuard>} />} />
              </>
            )}
            {canAccessLeadershipPages && (
              <Route path="/partner-portal/leadership/pipeline" element={<PrivateRoute element={<PartnerRouteGuard><LeadershipDashboardPage /></PartnerRouteGuard>} />} />
            )}
          </>
        )}

        {/* Private Routes */}
        {/* <Route path="/changePassword" element={<PrivateRoute element={<ChangePassword />} />} /> */}


        {isSalesUser ? (
          <>
            {enableSalesDemo && (
              <Route path="/sales/:id" element={<PrivateRoute element={<SalesDashboard />} />} />
            )}
            <Route path="/profile" element={<PrivateRoute element={<User_Profile />} />} />
            {enableEmailMigration && (
              <Route path="/update-email" element={<PrivateRoute element={<UpdateEmail />} />} />
            )}

            {enableContentStore && (
              <>
                <Route path="/store" element={<PrivateRoute element={<Content_Store />} />} />
                <Route path="/store/:fileformat" element={<PrivateRoute element={<Content_Store_Files />} />} />
                <Route path="/store/files/:id" element={<PrivateRoute element={<Content_Store_Det />} />} />
              </>
            )}

            {enableFaq && (
              <>
                <Route path="/faq" element={<PrivateRoute element={<FAQ_Page />} />} />
                <Route path="/faq/:id" element={<PrivateRoute element={<FAQ_Page_Quest />} />} />
              </>
            )}
            {enableWhatsNew && (
              <>
                <Route path="/what-new/:id" element={<PrivateRoute element={<WhatNew />} />} />
                <Route path="/what-new" element={<PrivateRoute element={<What />} />} />
              </>
            )}

            {enableEnablement && (
              <>
                <Route path="/learning" element={<PrivateRoute element={<LearningHubHome />} />} />
                <Route path="/learning/tracks/:id" element={<PrivateRoute element={<LearningHubMicroCerts />} />} />
                <Route path="/learning/microcert/:trackId/:microcertId" element={<PrivateRoute element={<LearningHubCourse />} />} />
                <Route path="/learning/dsom/:id" element={<PrivateRoute element={<DemoCentralTraining />} />} />
              </>
            )}

            {enableSalesDemo && (
              <Route path="/onboarding" element={<Onboarding />} />
            )}

            {isPAERoleUser && enableDemoIngestions && (
              <>
                <Route path="/catalogue" element={<PrivateRoute element={<Demo_Catalaugue />} />} />
                <Route path="/catalogue/:id" element={<PrivateRoute element={<Demo_Details_Page />} />} />
                <Route path="/catalogue/playbook/:id" element={<PrivateRoute element={<PlaybookView />} />} />
                <Route path="/reset" element={<PrivateRoute element={<Reset_Demo />} />} />
                <Route path="/narrative-catalogue" element={<PrivateRoute element={<Yads_Ingestion />} />} />
              </>
            )}

            {isPAERoleUser && enableBookings && (
              <Route path="/booking" element={<PrivateRoute element={<Tenant_Book />} />} />
            )}

            {enableSalesDemo && (
              <Route path="/secure-view" element={<SecureViewer />} />
            )}

            {enableAnalytics && canAccessStandaloneSeImpactAnalytics(currentUser) && (
              <Route
                path="/profile/se-activities-impact-analysis"
                element={<PrivateRoute element={<SEActivitiesImpactAnalysisPage />} />}
              />
            )}
          </>
        ) : (
          <>
            {shouldShowDemoCatalogue && enableDemoIngestions && (
              <>
                <Route path="/catalogue" element={<PrivateRoute element={<Demo_Catalaugue />} />} />
                <Route path="/catalogue/:id" element={<PrivateRoute element={<Demo_Details_Page />} />} />
                <Route path="/catalogue/playbook/:id" element={<PrivateRoute element={<PlaybookView />} />} />
                <Route path="/reset" element={<PrivateRoute element={<Reset_Demo />} />} />
                <Route path="/narrative-catalogue" element={<PrivateRoute element={<Yads_Ingestion />} />} />
              </>
            )}

            {shouldShowBookingPage && enableBookings && (
              <Route path="/booking" element={<PrivateRoute element={<Tenant_Book />} />} />
            )}

            <Route path="/profile" element={<PrivateRoute element={<User_Profile />} />} />
            {enableEmailMigration && (
              <Route path="/update-email" element={<PrivateRoute element={<UpdateEmail />} />} />
            )}
            {enableAnalytics && (
              <Route
                path="/profile/se-activities-impact-analysis"
                element={<PrivateRoute element={<SEActivitiesImpactAnalysisPage />} />}
              />
            )}

            {roleRoutes()}

            {/* <Route path="/idea-community" element={<PrivateRoute element={<IdeaCommunity />} />} />  */}

            {enableContentStore && (
              <>
                <Route path="/store" element={<PrivateRoute element={<Content_Store />} />} />
                <Route path="/store/:fileformat" element={<PrivateRoute element={<Content_Store_Files />} />} />
                <Route path="/store/files/:id" element={<PrivateRoute element={<Content_Store_Det />} />} />
              </>
            )}

            {enableFaq && (
              <>
                <Route path="/faq" element={<PrivateRoute element={<FAQ_Page />} />} />
                <Route path="/faq/:id" element={<PrivateRoute element={<FAQ_Page_Quest />} />} />
              </>
            )}
            {enableSearch && (
              <Route path="/search" element={<PrivateRoute element={<Search_Result />} />} />
            )}
            {enableWhatsNew && (
              <>
                <Route path="/what-new/:id" element={<PrivateRoute element={<WhatNew />} />} />
                <Route path="/what-new" element={<PrivateRoute element={<What />} />} />
              </>
            )}

            {enableSalesDemo && (
              <Route path="/onboarding" element={<Onboarding />} />
            )}

            {enableEnablement && (
              <>
                <Route path="/learning" element={<PrivateRoute element={<LearningHubHome />} />} />
                <Route path="/learning/tracks/:id" element={<PrivateRoute element={<LearningHubMicroCerts />} />} />
                <Route path="/learning/microcert/:trackId/:microcertId" element={<PrivateRoute element={<LearningHubCourse />} />} />
                <Route path="/learning/dsom/:id" element={<PrivateRoute element={<DemoCentralTraining />} />} />
              </>
            )}

            {enableSalesDemo && (
              <Route path="/sales/:id" element={<PrivateRoute element={<SalesDashboard />} />} />
            )}


            {enableSalesDemo && (
              <Route path="/secure-view" element={<SecureViewer />} />
            )}
          </>
        )}



        {/* 404 Page */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
